module.exports = __webpack_public_path__ + "img/CCaravan64_ua.b6b8c198.webp";